import { Component, Input } from '@angular/core';
import { AbstractFieldReadComponent } from '../base-field/abstract-field-read.component';
import { FeeValue } from './fee-value.model';

@Component({
  // tslint:disable-next-line
  selector: '[ccdReadOrderSummaryRow]',
  template: require('./read-order-summary-row.html'),
  styles: [
    require('./read-order-summary-row.scss')
  ],
})
export class ReadOrderSummaryRowComponent extends AbstractFieldReadComponent {

  @Input()
  feeValue: FeeValue;

  getFeeAmount(): string {
    return this.feeValue.value ? this.feeValue.value.FeeAmount : '';
  }
}
